import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TrainingItemGroupSearchComponent } from './training-item-group-search/training-item-group-search.component';
import { TrainingItemGroupPanelListComponent } from './training-item-group-panel-list/training-item-group-panel-list.component';
import { SharedModule } from "../shared/shared.module";
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';


@NgModule({
    declarations: [TrainingItemGroupSearchComponent, TrainingItemGroupPanelListComponent],
    imports: [
        CommonModule,
        BptSearchModule,
        SharedModule, 
        EmptyResultsComponent,
        SpinnerComponent,
    ],
    exports:[
      TrainingItemGroupSearchComponent,
      TrainingItemGroupPanelListComponent,
     
    ]
})
export class TrainingItemGroupSearchModule { }
